import { Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { withStyles, WithStyles } from "@mui/styles";
import MenuItem from '@mui/material/MenuItem';
import MuiAvatar from 'components/MuiExtras/MuiAvatar';
import * as React from 'react';
import { Formaters } from 'lib/Formarters';

const styles = (theme: Theme) => createStyles({
    line: {
        fontFamily: theme.typography.body1.fontFamily,
        fontSize: theme.typography.body1.fontSize,
        verticalAlign: "middle",
        height: "inherit",
        lineHeight: "36px",
        "& img": {
            maxWidth: "32px",
            maxHeight: "32px",
            float: "left",
            marginRight: "4px",
            objectFit: "scale-down"
        }
    },
});

interface IRenderSuggestionProps {
    highlightedIndex: number,
    index: number,
    itemProps: object,
    selectedItem: string,
    currentInputValue: string,
    suggestion: AutoCompleteDataModel;
}

type Props = IRenderSuggestionProps & WithStyles<typeof styles>;

class RenderSuggestion extends React.Component<Props>
{
    render() {
        const { currentInputValue, suggestion, index, itemProps, highlightedIndex, selectedItem } = this.props;
        const isHighlighted = highlightedIndex === index;
        const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;


        return (
            <MenuItem
                {...itemProps}
                key={suggestion.label}
                selected={isHighlighted}
                component="div"
                style={{ fontWeight: isSelected ? 500 : 400, }}
            >
                <Grid container justifyContent="center" alignItems="center">
                    {
                        suggestion.thumbnailUrl == null
                            ? <MuiAvatar>{suggestion.label.length > 0 ? suggestion.label[0] : "?"}</MuiAvatar>
                            : <MuiAvatar src={suggestion.thumbnailUrl} size="small" />
                    }
                    <Grid item xs zeroMinWidth>
                        <span dangerouslySetInnerHTML={{ __html: Formaters.htmlHighlightTerm(currentInputValue, suggestion.label, false, false) }}></span>
                    </Grid>
                </Grid>
            </MenuItem>
        );
    }
}


export default withStyles(styles)(RenderSuggestion);
